(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mindtra-early-access"] && !Shopify.designMode) return;
  try {
    
  function initializeMindtraForms() {
    document.querySelectorAll('.mea-form').forEach(function(form) {
      if (form.dataset.meaReady) return;
      form.dataset.meaReady = 'true';
      var tagField = form.querySelector('[data-mea-tags]');
      if (!tagField) return;
      var parameters = new URLSearchParams(window.location.search);
      var rawSource = (parameters.get('utm_source') || parameters.get('source') || '').toLowerCase();
      var sourceMap = {instagram:'social', ig:'social', facebook:'social', fb:'social', tiktok:'social', linkedin:'social', social:'social', website:'website', mindtra:'website', email:'email', mailchimp:'email', newsletter:'email', event:'event', qr:'event', referral:'referral'};
      var select = form.querySelector('[data-mea-source]');
      if (sourceMap[rawSource]) select.value = sourceMap[rawSource];
      function setTags() {
        var tags = ['40207324'];
        var audience = form.querySelector('[data-mea-audience]').value;
        if (audience) tags.push(audience);
        form.querySelectorAll('[data-mea-interest]:checked').forEach(function(input) { tags.push(input.value); });
        var sourceTags = {social:'40207325',website:'40207326',email:'40207327',event:'40207328',referral:'40207329'};
        if (sourceTags[select.value]) tags.push(sourceTags[select.value]);
        tagField.value = Array.from(new Set(tags)).join(',');
      }
      form.addEventListener('input', setTags);
      form.addEventListener('change', setTags);
      form.addEventListener('submit', setTags);
      setTags();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeMindtraForms);
  else initializeMindtraForms();
  document.addEventListener('shopify:section:load', initializeMindtraForms);

  } catch(e) { console.error(e); }
})();
})();
